module.exports = __webpack_public_path__ + "img/icono_fotovoltaica.51984406.svg";